// src/pages/backoffice/MenuEdit.jsx
import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import MenuCategoryFormModal from "./menuCategoryFormModal";
import Wrapper from "../_Wrapper";
import { getApiClient } from "../../libs/axiosInstance";
import { Link, useNavigate } from "react-router";

const axios = getApiClient();

export default function MenuEdit({ menuId }) {
  const navigate = useNavigate();
  const [menu, setMenu] = useState(null);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(null);

  useEffect(() => {
    loadAll();
  }, [menuId]);

  async function loadAll() {
    setLoading(true);
    try {
      const [mRes, cRes] = await Promise.all([
        axios.get(`/api/myshop/menus/${menuId}`),
        axios.get(`/api/myshop/menus/${menuId}/categories`),
      ]);
      setMenu(mRes.data.menu);
      setCategories(cRes.data.categories || []);
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Failed to load menu", "error");
    } finally {
      setLoading(false);
    }
  }

  async function handleDelete(cat) {
    const ok = await Swal.fire({
      title: `Delete ${cat.name}?`,
      text: "This cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Delete",
    });
    if (!ok.isConfirmed) return;

    try {
      await axios.delete(`/api/myshop/categories/${cat._id}`);
      loadAll();
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Delete failed", "error");
    }
  }

  return (
    <Wrapper>
      <div className="container py-3">
        {loading ? (
          <div className="text-center p-3">
            <div className="spinner-border" />
          </div>
        ) : (
          <>
            <div className="d-flex justify-content-between align-items-center mb-3">
              
              <h4 className="m-0"><Link to="/manage-menu" className="btn btn-primary">Back</Link> {menu?.name}</h4>
              <button
                className="btn btn-primary btn-sm"
                onClick={() => setShowForm({})}
              >
                + Category
              </button>
            </div>

            {categories.length === 0 ? (
              <div className="alert alert-light">No categories yet.</div>
            ) : (
              <table className="table table-sm align-middle">
                <thead>
                  <tr>
                    <th>Category</th>
                    <th>Subtitle</th>
                    <th>Items</th>
                    <th style={{ width: 140 }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {categories.map((c) => (
                    <tr key={c._id}>
                      <td>{c.name}</td>
                      <td>{c.subtitle}</td>
                      <td>{c.itemIds?.length || 0}</td>
                      <td>
                        <Link
                          className="btn btn-sm btn-outline-primary me-1"
                          to={`/manage-menu/${c._id}/items`}
                        >
                          Items
                        </Link>
                        <button
                          className="btn btn-sm btn-outline-secondary me-1"
                          onClick={() => setShowForm(c)}
                        >
                          Edit
                        </button>
                        <button
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => handleDelete(c)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </>
        )}

        {showForm && (
          <MenuCategoryFormModal
            initial={showForm}
            menuId={menuId}
            onClose={() => setShowForm(null)}
            onSaved={() => {
              setShowForm(null);
              loadAll();
            }}
          />
        )}
      </div>
    </Wrapper>
  );
}
